module.exports = __webpack_public_path__ + "img/Obond.2863c05b.svg";